import { useMemo, useCallback } from 'react'

import { useAccountScanners } from '../accounts'
import { IAccountScannerRespDto } from 'src/types'

export const useScannersConnectionsSelection = (
  selectedScanners: string[],
  setSelectedScanners: (ids: string[]) => void,
) => {
  const { data: items } = useAccountScanners()

  const itemsDictionary = useMemo(() => {
    const dictionary: { [id: string]: IAccountScannerRespDto } = {}
    items?.forEach((item) => {
      dictionary[item.id] = item
    })
    return dictionary
  }, [items])

  const selectedScannersConnections = useMemo(() => {
    if (!items?.length || !selectedScanners.length) return []

    return selectedScanners.reduce<IAccountScannerRespDto[]>((prev, id) => {
      const item = itemsDictionary[id]
      return item ? [...prev, item] : prev
    }, [])
  }, [selectedScanners, itemsDictionary, items?.length])

  const handleSelectedScanner = useCallback(
    (id: string) => {
      const index = selectedScanners.indexOf(id)
      const newSelectedScanners = [...selectedScanners]

      if (index !== -1) {
        newSelectedScanners.splice(index, 1)
      } else {
        newSelectedScanners.push(id)
      }

      setSelectedScanners(newSelectedScanners)
    },
    [selectedScanners, setSelectedScanners],
  )

  return { selectedScannersConnections, handleSelectedScanner }
}
